"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BitbucketReposIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
}, props));
BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var _default = exports.default = BitbucketReposIcon;